import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";
import apiClient from "../../utils/apiClient";
import CustomDataGrid from "../custom/CustomDataGrid";
import { formatDateTime } from "../../utils/date";

const ACTION_LABELS = {
  create: { label: "Pendaftaran", color: "info" },
  update: { label: "Edit Data", color: "warning" },
  confirm: { label: "Konfirmasi Anggota", color: "success" },
  reject: { label: "Tolak/Hapus Calon Anggota", color: "error" },
  impersonate_start: { label: "Mulai Impersonasi", color: "warning" },
  impersonate_end: { label: "Akhiri Impersonasi", color: "default" },
  delete_user: { label: "Hapus Anggota", color: "error" },
  login: { label: "Login", color: "success" },
  logout: { label: "Logout", color: "default" },
};

const columns = [
  {
    field: "created_at",
    headerName: "Waktu",
    width: 160,
    renderCell: ({ value }) => formatDateTime(value),
  },
  { field: "actor_name", headerName: "Aktor", width: 200 },
  {
    field: "action",
    headerName: "Aksi",
    width: 180,
    renderCell: ({ value }) => {
      const meta = ACTION_LABELS[value] || { label: value, color: "default" };
      return <Chip size="small" color={meta.color} label={meta.label} />;
    },
  },
  { field: "description", headerName: "Deskripsi" },
];

const ActivityLogData = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get("/activity-logs")
      .then((response) => {
        setRows(response.data.data.map((log) => ({ ...log, id: log.id })));
      })
      .catch((error) => {
        console.error("Error fetching activity logs", error);
      })
      .finally(() => setLoading(false));
  }, []);

  return <CustomDataGrid rows={rows} columns={columns} loading={loading} />;
};

export default ActivityLogData;
